import styled from 'styled-components';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';

// eslint-disable-next-line import/prefer-default-export
export const InformationalModuleStyled = styled(InformationalModule)`
  /* temporary until info module fixes images globally */
  img {
    width: 100%;
  }
`;
